import React from "react";

export default function CloseIconNoti() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 513 513"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M512.59 52.0071L461.024 0.441406L256.59 204.876L52.1556 0.441406L0.589844 52.0071L205.024 256.441L0.589844 460.876L52.1556 512.441L256.59 308.007L461.024 512.441L512.59 460.876L308.156 256.441L512.59 52.0071Z"
        fill="white"
      />
    </svg>
  );
}
